import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

import { Popup, PopupProps } from 'vant'
import { withDefaults, CSSProperties } from 'vue'
import PopupHeader from './popup-header.vue'
import type { StyleValue } from 'vue'


import { defineComponent } from 'vue'
const __default__ = defineComponent({
  components: {},
  name: 'common-wrap',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    show: { type: Boolean, default: false },
    title: null,
    style: { default: () => ({
      backgroundColor: '#F6F7F8',
    }) },
    vantPopupProps: { default: null },
    showHeaderClose: { type: Boolean, default: true },
    headerStyle: null,
    teleport: null,
    showHeader: { type: Boolean, default: true }
  },
  emits: ['update:show'],
  setup(__props: any, { emit: emits }) {

const props = __props as { show: boolean, title: string, style: CSSProperties, vantPopupProps: Partial<PopupProps>, showHeaderClose: boolean, headerStyle?: StyleValue, teleport?: string, showHeader: boolean };




async function headerCloseHandle() {
  if (props?.vantPopupProps?.beforeClose) {
    const bool = await props?.vantPopupProps?.beforeClose()
    if (!bool) {
      return
    }
  }
  hidePopup()
}
function hidePopup() {
  emits('update:show', false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Popup), _mergeProps({
    show: props.show,
    position: "bottom",
    class: "common-popup-wrap",
    onClickCloseIcon: hidePopup
  }, props.vantPopupProps, {
    style: props.style,
    teleport: props.teleport,
    "onUpdate:show": _cache[0] || (_cache[0] = (value) => emits('update:show', value))
  }), {
    default: _withCtx(() => [
      (props.showHeader)
        ? (_openBlock(), _createBlock(PopupHeader, {
            key: 0,
            onClose: headerCloseHandle,
            title: props.title,
            "header-style": props.headerStyle,
            showClsoe: props.showHeaderClose
          }, null, 8, ["title", "header-style", "showClsoe"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["show", "style", "teleport"]))
}
}

})